<template>
    <div>
        <div class="row">
            <div class="col-12 col-sm-12">
                <h1 class="title is-4 text-capitalize">
                    {{ $t('booking.header.booking') }}
                </h1>
            </div>
            <div class="col-12 col-sm-12  text-capitalize">
                 {{ bookingContext.availabilityCar.category }} - {{ bookingContext.availabilityCar.model }}
                <b>, {{ bookingContext.availabilityCar.duration }}  {{ $t('booking.header.days') }}</b>
                <span>, {{ $t('booking.header.from') }}&nbsp;<span class="from-date">{{ avail.startTime | formatDateTime }}</span></span>&nbsp;
                <span>{{ $t('booking.header.to') }}&nbsp;<span class="to-date">{{ avail.endTime | formatDateTime }}</span></span>
                <br>
                {{ $t('booking.header.price') }} : <span class="price">{{ bookingContext.availabilityCar.prixTTC | currency }} </span>
                , Options :  <span class="price"> {{ bookingContext.availabilityCar.supplementsPrixTTC | currency }}</span>
                , Total :<span class="price"> {{ bookingContext.availabilityCar.totalTTC | currency }}</span>
                <br> {{$t('booking.availability_car_card.deposit')}} :  <span class="price">{{ bookingContext.availabilityCar.getCaution | currency}} </span>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {

    computed: {
        ...mapGetters({
            avail: 'booking/avail',
            bookingContext:'booking/context'
        })
    }
}
</script>

<style scoped>
.from-date { color: #2196F3; }
.to-date { color: crimson; }
.price { color: darkgreen;font-weight:600; }
</style>
